import { ID_GROUPS, idGroupBR } from "../../../../Utils/const";

export const DOMAIN = {
    DASHBOARD: "/app/dashboard",
    MAP: "/app/map",
    MONITOR: "/app/monitor",
    ZONE: "/app/zone",
    GROUP: "/app/group",
    SENSOR: "/app/sensor",
    USER: "/app/user",
    CAMERA: "/app/camera",
    HELP: "/app/help",
    MONITOR_DOT: "/app/monitor/list",
    CHART: "/app/chart",
    AUDIO: "/app/help/audio",
    PARAMS: "/app/params",
    EXPLOIT: "/app/exploit",
    OPERATE: "/app/operate",
    TRANSFER: "/app/transfer",
}

export function CUSTOM_SIDEBAR(index) {
    switch (index) {
        case +0:
            return DOMAIN.DASHBOARD

        case +1:
            if (window.localStorage.getItem('group_id') === ID_GROUPS.DOT) {
                return DOMAIN.MONITOR_DOT
            } else if(idGroupBR.includes(window.localStorage.getItem('group_id'))) {
                return DOMAIN.MAP
            }
            return DOMAIN.HELP

        case +2:
            if (window.localStorage.getItem('group_id') === ID_GROUPS.KG) {
                return DOMAIN.MONITOR_DOT
            } else if (window.localStorage.getItem('group_id') === ID_GROUPS.DOT) {
                return DOMAIN.CHART
            } else if (window.localStorage.getItem('group_id') === ID_GROUPS.AC) {
                return DOMAIN.MONITOR_DOT
            } else if(idGroupBR.includes(window.localStorage.getItem('group_id'))) {
                return DOMAIN.MONITOR_DOT
            }
            // return DOMAIN.MONITOR
            return;

        case +3:
            if (window.localStorage.getItem('group_id') === ID_GROUPS.KG) {
                return DOMAIN.CHART
            } else if (window.localStorage.getItem('group_id') === ID_GROUPS.DOT) {
                return DOMAIN.HELP
            } else if(idGroupBR.includes(window.localStorage.getItem('group_id'))) {
                return DOMAIN.PARAMS
            }
            return DOMAIN.USER

        case +4:
            if (window.localStorage.getItem('group_id') === ID_GROUPS.KG || window.localStorage.getItem('group_id') === ID_GROUPS.DOT) {
                return DOMAIN.USER
            } else if(idGroupBR.includes(window.localStorage.getItem('group_id'))) {
                return DOMAIN.EXPLOIT
            }
        // return DOMAIN.GROUP

        case +5:
            if (window.localStorage.getItem('group_id') === ID_GROUPS.AC) return DOMAIN.AUDIO
            else if(idGroupBR.includes(window.localStorage.getItem('group_id'))) {
                return DOMAIN.GROUP
            }
            return DOMAIN.SENSOR

        case +6:
            if(idGroupBR.includes(window.localStorage.getItem('group_id'))) {
                return DOMAIN.OPERATE
            }
            return DOMAIN.USER

        case +7:
            if(idGroupBR.includes(window.localStorage.getItem('group_id'))) {
                return DOMAIN.TRANSFER
            }
            return DOMAIN.CAMERA
        case +8:
            if(idGroupBR.includes(window.localStorage.getItem('group_id'))) {
                return DOMAIN.USER
            }
        return DOMAIN.DASHBOARD
        default:
            return DOMAIN.DASHBOARD
    }
}

export function APP_TITLE(domain) {
    switch (domain) {
        case DOMAIN.ZONE:
            return "Danh sách khu vực";
        case DOMAIN.GROUP:
            return "Danh sách công trình";
        case DOMAIN.SENSOR:
            return "Danh sách trạm đo";
        case DOMAIN.USER:
            return "Quản lý người dùng";
        case DOMAIN.CAMERA:
            return "Quản lý camera";
        case DOMAIN.HELP:
            return "Hỗ trợ vận hành"
        default:
            return "";
    }
}

export const drawerWidth = 250;
export const Menu = () => {
    if (window.localStorage.getItem('group_id') === ID_GROUPS.KG) {
        return ["Bảng tin", "Hỗ trợ vận hành", "Dữ liệu lịch sử", "Biểu đồ", "Quản lý tài khoản"]
    } else if (window.localStorage.getItem('group_id') === ID_GROUPS.DOT) {
        return ["Bảng tin", "Dữ liệu lịch sử", "Biểu đồ", "Hỗ trợ vận hành", "Quản lý tài khoản"]
    } else if (window.localStorage.getItem('group_id') === ID_GROUPS.AC) {
        return ["Bảng tin", "Hỗ trợ vận hành", "Dữ liệu lịch sử", "Quản lý tài khoản", "Loa cảnh báo"]
    } else if (idGroupBR.includes(window.localStorage.getItem('group_id'))) {
        return ["Bảng tin", "Bản đồ", "Dữ liệu lịch sử", "Thông số hồ", "Khai thác CSDL", "Quản lý công trình", "QL số liệu vận hành", "QLTT truyền dữ liệu", "Quản lý tài khoản"]
    }
    else return ["Bảng tin", "Hỗ trợ vận hành", "Dữ liệu lịch sử", "Quản lý tài khoản"]
} 
